import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumberInput_pointFont } from "../../../../../Components";
import {
  updateFontStyleState,
  saveFontStyle,
} from "../../../../../Redux/actions/projectActions";

const LineHeight = ({ styleKey, syncKeys = [], currentBlockType, isCard }) => {
  const dispatch = useDispatch();
  const fontStyle = useSelector((state) => state?.project?.fontStyle ?? {});
  const value = fontStyle?.[styleKey]?.lineHeight ?? 1;
  const debounceTimeoutIds = useRef({});
  const extraKeys = Array.isArray(syncKeys) ? syncKeys.join(",") : "";

  useEffect(() => {
    return () => {
      Object.values(debounceTimeoutIds.current).forEach((timer) => {
        if (timer) clearTimeout(timer);
      });
    };
  }, []);

  const onChange = useCallback(
    (val) => {
      const num = parseFloat(val);
      if (Number.isNaN(num)) return;
      const clamped = Math.min(Math.max(num, 0.8), 5.0);
      const keys = extraKeys ? [styleKey, ...extraKeys.split(",")] : [styleKey];
      keys.forEach((key) => {
        dispatch(
          updateFontStyleState(key, "lineHeight", clamped, currentBlockType),
        );
        const timerKey = `${key}:lineHeight`;
        if (debounceTimeoutIds.current[timerKey]) {
          clearTimeout(debounceTimeoutIds.current[timerKey]);
        }
        debounceTimeoutIds.current[timerKey] = setTimeout(() => {
          dispatch(
            saveFontStyle(
              key,
              currentBlockType,
              "lineHeight",
              clamped,
              null,
              isCard,
            ),
          );
        }, 1000);
      });
    },
    [dispatch, styleKey, extraKeys, currentBlockType, isCard],
  );

  return (
    <NumberInput_pointFont
      step="0.10"
      min="0.80"
      max="5.0"
      comp="lineHeight"
      value={value}
      onChange={onChange}
    />
  );
};

export default LineHeight;
